import { useTenantContext } from '@trashlab/sitesapp/src/organizations/fasttrac/contexts/use-tenant-context';
import type { HydratedOrderPhoto } from '@trashlab/api/src/domains/orders/types/order-photo';
import { DefaultTemplateVariableType } from '@trashlab/api/src/domains/website/types/variable-types';

type ArrayValue = {
  value: string;
  orderIndex?: number;
};

export function useVariantValue<T extends string | ArrayValue[]>(
  variableType: DefaultTemplateVariableType,
  defaultValue?: T,
): T {
  const { website } = useTenantContext();
  const [variant] = website?.site_variant ?? [];

  const variables = variant?.site_variant_variable?.filter(
    (variable) => variable.variableType === variableType,
  );

  if (variables?.[0]?.order_photos) {
    const photo = variables[0].order_photos as unknown as HydratedOrderPhoto;
    return (photo.signedUrl || photo.url || defaultValue) as T;
  }

  const dbValues =
    variables?.map((variable) => ({
      value: variable.value,
      orderIndex: variable.orderIndex ?? 0,
    })) ?? [];

  if (Array.isArray(defaultValue)) {
    if (dbValues.length > 0) {
      return dbValues as T;
    }

    return defaultValue.map((v, index) => {
      if (typeof v === 'object' && v !== null) {
        return v as ArrayValue;
      }
      return { value: v as string, orderIndex: index };
    }) as T;
  }

  const firstValue = dbValues[0]?.value;
  return (firstValue ?? defaultValue ?? '') as T;
}
